const Error: React.FC<Props> = ({ children, extraClasses = '' }) => <p className={`error-text ${extraClasses}`}>{children}</p>;

interface Props {
    extraClasses?: string;
}

export default Error;
